import React from 'react'
import smmimg1 from './images/smm1.png'
import smmimg2 from './images/smm2.png'
export default function SmmProces() {
  return (
    <>
      <div className="container smmImg-main">
        <div className="row row-cols-2 smmImg-sub-main">
            <div className="col smm-large-Img">
                <img src={smmimg1} alt="" />
            </div>
            <div className="col smm-small-Img">
                <img src={smmimg2} alt="" />
            </div>
        </div>
      </div>
      <div className="smm-process-main">
        <div className="header-process-main">
            <h1>Social Media Strategy Fundamentals</h1>
        </div>
        <div className="para-process-main">
            <p>
            In today’s hyper-connected digital landscape, social media has become far more than just a communication tool—it’s a primary source of news, a platform for storytelling, and a critical pillar in search engine visibility and digital marketing success.
            </p>
            <p>
            With over 5.24 billion active users worldwide—representing nearly 64% of the global population—social media is no longer optional for businesses; it’s essential. According to Global WebIndex, users now spend an average of 2 hours and 24 minutes daily engaging across eight or more platforms, making social media the most dynamic place to reach your audience.
            </p>
            <p>
            At Raj Digital Marketing, we understand that building a strong social media presence requires more than just frequent posts. It demands a strategic approach tailored to your audience, brand voice, and industry. Unfortunately, many businesses enter the social media space without a clear understanding of what works and what doesn’t—wasting valuable time and resources.
That’s where we come in. Our social media specialists help you navigate the differences between B2C and B2B marketing, choose the right platforms for your business, and craft a strategy that connects, engages, and converts.
Learn how to leverage social platforms effectively with a structured plan, expert insights, and a focus on measurable growth. Let Raj Digital Marketing guide you from setup to success in your social media journey.

            </p>
        </div>
      </div>
    </ >
  )
}
